define('lq/events/actions/eventAction',[
    'jquery',
    'lq/oop'
], function ($, oop) {
	'use strict';

	function EventAction(eventData, eventArg) {
	    this.eventData = eventData;
	    this.eventArg = eventArg;
	}

    oop.makeExtendable(EventAction);

    EventAction.DO_NOT_BATCH = "no-batch";
    EventAction.QUERY_BATCH = "query-batch";
    EventAction.COMMAND_BATCH = "command-batch";

    EventAction.prototype.getBatchType = function () {
        throw new Error('please override \'getBatchType()\' of EventAction');
    };

    EventAction.prototype.createEventActionRequest = function () {
        return undefined;
    };
        
    EventAction.prototype.execute = function (continuation, eventActionResponse) {
        continuation();
    };

    EventAction.prototype.eventIsEnabled = function (eventName) {
        return this.eventData.eventing && this.eventData.eventing[eventName] && this.eventData.eventing[eventName].enabled;
    };

    EventAction.prototype.triggerEvent = function (eventName, next, param) {
        this.piping.eventing.publish(this.eventData.eventing[eventName].raisedEventName, this.eventSource, param, next);
    };

    return EventAction;
});
